import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/index/slider/banner-03.jpg")